import CategoryService from './category.service';
import CouponService from './coupon.service';
import DeliveryCostService from './delivery-cost.service';
import DeliveryTimeService from './deliveryTime.service';
import LocalizationService from './localization.service';
import OrderService from './order.service';
import UserService from './user.service';

export enum ServiceTypes {
  CATEGORY_SERVICE = 'CATEGORY_SERVICE',
  USER_SERVICE = 'USER_SERVICE',
  ORDER_SERVICE = 'ORDER_SERVICE',
  COUPON_SERVICE = 'COUPON_SERVICE',
  DELIVERY_COST_SERVICE = 'DELIVERY_COST_SERVICE',
  DELIVERY_TIME_SERVICE = 'DELIVERY_TIME_SERVICE',
  LOCALIZATION_SERVICE = 'LOCALIZATION_SERVICE',
  AUTH_SERVICE = 'AUTH_SERVICE',
  CONTENT_SERVICE = 'CONTENT_SERVICE',
}

export class ServiceFactory {
  private static services: any = {};

  static getServiceInstance(type: ServiceTypes) {
    if (!this.services[type]) {
      if (type === ServiceTypes.CATEGORY_SERVICE) {
        this.services[type] = new CategoryService();
      }
      if (type === ServiceTypes.USER_SERVICE) {
        this.services[type] = new UserService();
      }
      if (type === ServiceTypes.ORDER_SERVICE) {
        this.services[type] = new OrderService();
      }
      if (type === ServiceTypes.COUPON_SERVICE) {
        this.services[type] = new CouponService();
      }
      if (type === ServiceTypes.DELIVERY_COST_SERVICE) {
        this.services[type] = new DeliveryCostService();
      }
      if (type === ServiceTypes.DELIVERY_TIME_SERVICE) {
        this.services[type] = new DeliveryTimeService();
      }
      if (type === ServiceTypes.LOCALIZATION_SERVICE) {
        this.services[type] = new LocalizationService();
      }
    }
    return this.services[type];
  }

  static get<T>(type: ServiceTypes) {
    if (!this.services[type]) {
      if (type === ServiceTypes.CATEGORY_SERVICE) {
        this.services[type] = new CategoryService();
      }
      if (type === ServiceTypes.USER_SERVICE) {
        this.services[type] = new UserService();
      }
      if (type === ServiceTypes.ORDER_SERVICE) {
        this.services[type] = new OrderService();
      }
      if (type === ServiceTypes.COUPON_SERVICE) {
        this.services[type] = new CouponService();
      }
      if (type === ServiceTypes.DELIVERY_COST_SERVICE) {
        this.services[type] = new DeliveryCostService();
      }
      if (type === ServiceTypes.DELIVERY_TIME_SERVICE) {
        this.services[type] = new DeliveryTimeService();
      }
    }
    return this.services[type] as T;
  }
}
